import React, { useState } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const qaData = [
  {
    question: "加入御林安全工作室需要什么基础？",
    answer: "我们对基础要求相对宽松，只要你对信息安全有浓厚兴趣即可。无论是零基础还是有一定经验的同学，我们都欢迎。我们会提供系统的培训和学习资源，帮助你快速成长。最重要的是你的学习态度和团队协作精神。"
  },
  {
    question: "工作室的日常活动是怎样的？",
    answer: "我们有定期的技术分享会、CTF训练、项目实战等活动。平时成员会一起学习新技术、讨论安全动态、参与各类比赛。每周都有固定时间的技术交流，每月会组织一次大型技术分享或实战演练。"
  },
  {
    question: "如何加入御林安全工作室？",
    answer: "我们每学期初会进行招新，你可以关注我们的招新通知。招新流程包括简历筛选、技术面试和团队面试。我们更看重你的潜力和学习能力，而不是现有技术水平。平时也可以通过参加我们的公开活动来了解我们。"
  },
  {
    question: "工作室提供哪些学习资源？",
    answer: "我们有丰富的学习资源库，包括安全工具、学习文档、实战靶场等。工作室内部有专门的学习平台，提供系统化的学习路径。学长学姐会定期分享学习经验，我们也会邀请行业专家进行技术讲座。"
  },
  {
    question: "加入后需要承担什么责任？",
    answer: "我们希望成员能够积极参与团队活动，定期进行技术学习和分享。参加重要的比赛和项目时需要投入相应的时间和精力。同时也要帮助新成员成长，传承工作室的技术和文化。"
  },
  {
    question: "工作室的未来发展方向是什么？",
    answer: "我们计划在网络安全领域深耕，培养更多优秀人才。未来会加强与企业的合作，参与更多实际项目。同时也会在学术研究方面有所突破，产出更多高质量的研究成果和技术文章。"
  }
];

function QASection() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);

  const toggleQA = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section ref={sectionRef} id="Q&A" className="section qa-section" aria-labelledby="qa-title" style={{
      background: '#FFFFFF',
      position: 'relative',
      opacity: isSectionVisible ? 1 : 0,
      transform: isSectionVisible ? 'translateY(0)' : 'translateY(50px)',
      transition: 'all 1s cubic-bezier(0.23, 1, 0.32, 1)'
    }}>
      <div className="container">
        <h2 id="qa-title" className="section-heading animate-fadeInUp" style={{ position: 'relative', zIndex: 1 }}>
          常见问题
        </h2>
        
        <div style={{ marginTop: 'var(--space-16)', position: 'relative', zIndex: 1 }}>
          {qaData.map((qa, index) => (
            <div 
              key={index}
              className="animate-fadeInUp"
              style={{ 
                animationDelay: `${index * 0.1}s`,
                marginBottom: 'var(--space-6)'
              }}
            >
              <div 
                className="qa-pair"
                style={{
                  overflow: 'hidden',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  cursor: 'pointer',
                  position: 'relative',
                  padding: 'var(--space-6)'
                }}
                onClick={() => toggleQA(index)}
              >
                {/* 问题部分 */}
                <div 
                  className="qa-question"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 'var(--space-4)',
                    position: 'relative',
                    zIndex: 2
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h3 
                      style={{
                        fontSize: '1.3rem',
                        fontWeight: 'var(--font-semibold)',
                        color: 'var(--text-brand)',
                        marginBottom: 'var(--space-2)',
                        lineHeight: 'var(--leading-tight)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--space-3)'
                      }}
                    >
                      <span 
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px',
                          borderRadius: 'var(--radius-full)',
                          background: 'var(--gradient-brand)',
                          color: '#FFFFFF',
                          fontSize: '1rem',
                          fontWeight: 'var(--font-bold)',
                          flexShrink: 0
                        }}
                      >
                        Q{index + 1}
                      </span>
                      {qa.question}
                    </h3>
                  </div>
                  
                  {/* 展开/收起图标 */}
                  <div 
                    style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: 'var(--radius-full)',
                      background: expandedIndex === index 
                        ? 'var(--gradient-accent)' 
                        : 'var(--bg-tertiary)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      flexShrink: 0
                    }}
                  >
                    <svg 
                      width="16" 
                      height="16" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      style={{
                        color: 'var(--text-primary)',
                        transform: expandedIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <path d="M19 9l-7 7-7-7"/>
                    </svg>
                  </div>
                </div>
                
                {/* 答案部分 */}
                <div 
                  className="qa-answer"
                  style={{
                    maxHeight: expandedIndex === index ? '500px' : '0',
                    opacity: expandedIndex === index ? 1 : 0,
                    overflow: 'hidden',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    zIndex: 2
                  }}
                >
                  <div 
                    style={{
                      padding: 'var(--space-4) 0 0 0',
                      transition: 'all 0.4s ease'
                    }}
                  >
                    <div 
                      style={{
                        fontSize: '1.1rem',
                        lineHeight: 'var(--leading-relaxed)',
                        color: 'var(--text-secondary)',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 'var(--space-3)'
                      }}
                    >
                      <span 
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px',
                          borderRadius: 'var(--radius-full)',
                          background: 'var(--gradient-secondary)',
                          color: '#FFFFFF',
                          fontSize: '1rem',
                          fontWeight: 'var(--font-bold)',
                          flexShrink: 0,
                          marginTop: '2px'
                        }}
                      >
                        A
                      </span>
                      <span>{qa.answer}</span>
                    </div>
                  </div>
                </div>
                
                {/* 底部装饰线 */}
                <div 
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '3px',
                    background: expandedIndex === index 
                      ? 'var(--gradient-brand)' 
                      : 'transparent',
                    transition: 'all 0.4s ease'
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default QASection;